<template>
  <p class="h5 px-3 pt-3 mb-1">
    {{ `${getCurrentCustomer.firstName} ${getCurrentCustomer.lastName}` }}
  </p>
  <ul
    class="list-unstyled m-0 text-primary"
    role="list"
    data-cy="profile-dropdown"
  >
    <li class="flex py-1 px-3 relative items-center">
      <i class="mi-user-fill icon-24" />
      <router-link
        :to="{ name: 'customerProfilePath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('my_account') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      v-if="country !== 'at' && country !== 'fr'"
      class="flex py-1 px-3 relative items-center border-top"
    >
      <i class="mi-cash-bag icon-24" />
      <router-link
        v-if="!getCurrentCustomer.inPlusClub"
        :to="{ name: 'mixitPlusPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        <MixitPlusLogoSvg
          width="120"
          class="mb-n2 relative"
        />
      </router-link>
      <router-link
        v-else
        :to="{ name: 'customerProfilePath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        <MixitPlusLogoSvg width="100" />
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      v-if="locale === 'cs' || locale === 'sk'"
      class="flex py-1 px-3 relative items-center border-top"
    >
      <i class="mi-bird icon-24" />
      <router-link
        v-if="activeClubMembership"
        :to="{ name: 'clubMembershipStatusPath', params: { hash: activeClubMembership.uniqHash } }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('mixit_club') }}
      </router-link>
      <router-link
        v-else
        :to="{ name: 'clubPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('mixit_club') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-heart-fill text-danger icon-24" />
      <router-link
        :to="{ name: 'customerMixesPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('favorite_mixes') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-map-pin icon-24" />
      <router-link
        :to="{ name: 'customerAddressesPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('my_addresses') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-stopwatch icon-24" />
      <router-link
        :to="{ name: 'ordersPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('orders_history') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-credits icon-24" />
      <router-link
        :to="{ name: 'customerCreditsPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('my_credits') }} <span v-if="creditsSum >= 1">({{ Math.floor(creditsSum) }})</span>
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-frozen icon-24" />
      <router-link
        :to="{ name: 'customerWatchdogProductsPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('watchdog') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      v-if="country !== 'at' && country !== 'fr'"
      class="flex py-1 px-3 relative items-center border-top"
    >
      <i class="mi-star icon-24" />
      <router-link
        :to="{ name: 'customerBadges' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('my_badges') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      class="flex py-1 px-3 relative items-center border-top"
    >
      <i class="mi-comment icon-24" />
      <router-link
        :to="{ name: 'customerSupportPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('support') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      class="flex py-1 px-3 relative items-center border-top"
    >
      <i class="mi-cookies icon-24" />
      <router-link
        :to="{ name: 'customerSettingsPath' }"
        class="block p-2 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('settings') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <i class="mi-sign-out icon-24" />
      <button
        type="button"
        class="btn btn-outline-none text-left block p-2 font-normal text-sm uppercase flex-grow-1 leading-sm stretched-link"
        data-cy="sign-out-button"
        @click="signOut"
      >
        {{ t('sign_out') }}
      </button>
      <i class="mi-chevron-r icon-12" />
    </li>
  </ul>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import MixitPlusLogoSvg from '@/components/svg/MixitPlusLogoSvg.vue'
import { useAppStore } from '@/stores/AppStore'
import { useCartStore } from '@/stores/CartStore'
import { useModalStore } from '@/stores/ModalStore'
import { useCountry } from '@/mixins/useCountry'

const country = useCountry()

const { t, locale } = useI18n()

const router = useRouter()
const { openModal } = useModalStore()

const appStore = useAppStore()
const { getCurrentCustomer, isSignedIn } = storeToRefs(appStore)

const cartStore = useCartStore()

const creditsSum = ref(0)
const clubMemberships = ref([])

const signOut = () => {
  appStore.signOut()
  cartStore.resetCart()
  router.push({ name: 'rootPath' })
  openModal({
    id: 'modal-alert',
    title: t('you_have_successfully_logged_out'),
  })
}

const loadCredits = async () => {
  if (isSignedIn.value) {
    const { data } = await ApiServiceV1.get('customer/customer_credits')
    creditsSum.value = data.creditsSum
  }
}

const loadClubMemberships = async () => {
  if (isSignedIn.value) {
    const { data } = await ApiServiceV1.get(`club/memberships`)
    clubMemberships.value = [...clubMemberships.value, ...data.clubMemberships]
  }
}

const activeClubMembership = computed(
    () => clubMemberships.value.find(m => m.status === 'active') || null
)

loadCredits()
loadClubMemberships()
</script>

<i18n>
  {
    "cs": {
    "favorite_mixes": "Oblíbené mixy",
    "mixit_club": "Mixit Klub",
    "my_account": "Můj účet",
    "my_addresses": "Moje adresy",
    "my_badges": "Moje odznaky",
    "my_credits": "Moje kredity",
    "orders_history": "Historie objednávek",
    "settings": "Nastavení",
    "sign_out": "Odhlásit",
    "support": "Podpora",
    "voucher_permalink": "mixit-plus-na-12-mesicu",
    "watchdog": "Hlídané zobání",
    "you_have_successfully_logged_out": "Úspěšně jste se odhlásili"
},
    "sk": {
    "favorite_mixes": "Obľúbené mixy",
    "mixit_club": "Mixit Klub",
    "my_account": "Môj účet",
    "my_addresses": "Moje adresy",
    "my_badges": "Moje odznaky",
    "my_credits": "Moje kredity",
    "orders_history": "História objednávok",
    "settings": "Nastavenia",
    "sign_out": "Odhlásiť",
    "support": "Podpora",
    "voucher_permalink": "mixit-plus-na-12-mesiacov",
    "watchdog": "Strážené zobkanie",
    "you_have_successfully_logged_out": "Úspešne ste sa odhlásili"
},
    "pl": {
    "favorite_mixes": "Ulubione mieszanki",
    "mixit_club": "Klub Mixit",
    "my_account": "Moje konto",
    "my_addresses": "Moje adresy",
    "my_badges": "Moje odznaki",
    "my_credits": "Moje punkty",
    "orders_history": "Historia zamówień",
    "settings": "Ustawienia",
    "sign_out": "Wyloguj",
    "support": "Pomoc",
    "voucher_permalink": "mixit-plus-na-12-miesiecy",
    "watchdog": "Produkty, na które czekasz",
    "you_have_successfully_logged_out": "Wylogowanie przebiegło prawidłowo"
},
    "hu": {
    "favorite_mixes": "Kedvenc mixeim",
    "mixit_club": "Mixit Klub",
    "my_account": "Fiókom",
    "my_addresses": "Címeim",
    "my_badges": "A jelvényeim",
    "my_credits": "Kreditek",
    "orders_history": "Rendeléseim",
    "settings": "Beállítások",
    "sign_out": "Kijelentkezés",
    "support": "Támogatás",
    "voucher_permalink": "mixit-plusz-12-honapra",
    "watchdog": "Őrzött csipegetés",
    "you_have_successfully_logged_out": "Sikeresen kijelentkeztél"
},
    "de": {
    "favorite_mixes": "Favoriten",
    "mixit_club": "Mixit Club",
    "my_account": "Mein Konto",
    "my_addresses": "Meine Adressen",
    "my_badges": "Meine Abzeichen",
    "my_credits": "Meine Punkte",
    "orders_history": "Bestellverlauf",
    "settings": "Einstellungen",
    "sign_out": "Abmelden",
    "support": "Unterstützung",
    "voucher_permalink": "mixit-plus-fuer-12-monate",
    "watchdog": "Beobachtete Produkte",
    "you_have_successfully_logged_out": "Erfolgreich abgemeldet"
},
    "at": {
    "favorite_mixes": "Favoriten",
    "mixit_club": "Mixit Club",
    "my_account": "Mein Konto",
    "my_addresses": "Meine Adressen",
    "my_badges": "Meine Abzeichen",
    "my_credits": "Meine Punkte",
    "orders_history": "Bestellverlauf",
    "settings": "Einstellungen",
    "sign_out": "Abmelden",
    "support": "Unterstützung",
    "voucher_permalink": "mixit-plus-fuer-12-monate",
    "watchdog": "Beobachtete Produkte",
    "you_have_successfully_logged_out": "Erfolgreich abgemeldet"
},
    "ro": {
    "favorite_mixes": "Mixuri favorite",
    "mixit_club": "Club Mixit",
    "my_account": "Contul meu",
    "my_addresses": "Adresele mele",
    "my_badges": "Insignele mele",
    "my_credits": "Creditele mele",
    "orders_history": "Istoria comenzilor",
    "settings": "Setări",
    "sign_out": "Ieșire din cont",
    "support": "Asistență",
    "voucher_permalink": "mixit-plus-de-12-luni",
    "watchdog": "Produse monitorizate",
    "you_have_successfully_logged_out": "Ai ieșit cu succes din cont"
},
    "fr": {
    "favorite_mixes": "Mix préférés",
    "mixit_club": "Mixit Club",
    "my_account": "Mon compte",
    "my_addresses": "Mes adresses",
    "my_badges": "Mes badges",
    "my_credits": "Mes crédits",
    "orders_history": "Historique des commandes",
    "settings": "Paramètres",
    "sign_out": "Se désinscrire",
    "support": "Assistance",
    "voucher_permalink": "mixit-plus-pour-12-mois",
    "watchdog": "Produits surveillés",
    "you_have_successfully_logged_out": "Vous vous êtes déconnecté avec succès"
}
  }
</i18n>
